import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { LogoutOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Dropdown, Space } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
import { DeleteToken } from "../../utils";
import store from "./../../redux/store";
import { UserServices } from "../../redux/Services";
import jwt_decode from "jwt-decode";
import { useAsyncAction } from "../../hooks/useAsyncAction";
const TopBar = ({ collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const [handleLogout, loggingOut] = useAsyncAction(async () => {
    /* navigate("/login", { replace: true }); */
    const respo = await UserServices.logoutUserApi();
    if (respo) {
      store?.dispatch({ type: "LOGOUT" });
      DeleteToken();
      console.log(respo, "Logout response");
      window.location.href = "/login";
    }
  });

  const token = localStorage.getItem("lpl_abha:token");
  const decoded = jwt_decode(token);
  const menu = (
    <div className="profile2">
      <div>
        <Button
          className="profile-btn"
          icon={<UserOutlined />}
          type="text"
        ></Button>
      </div>
      <div>
        <h5><strong>Name:</strong> {decoded.name}</h5>
        <h5><strong>Email:</strong> {decoded.email}</h5>
        <h5><strong>Mobile:</strong> {decoded.mobile}</h5>
        {decoded.organization_id && (
          <h5><strong>Organization:</strong> {decoded.organization_name || ""} ({decoded.organization_id})</h5>
        )}
      </div>
    </div>
  );

  return (
    <div className="flex justify-content-between align-items-center">
      <div>
        {React.createElement(
          collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
          {
            className: "trigger",
            onClick: () => setCollapsed(!collapsed),
          }
        )}
      </div>
      <div className="mr-20">
        <Dropdown overlay={menu} trigger={["hover"]}>
          <Button className="profile-btn2" type="text">
            <Space align="center">
              <UserOutlined />
              <span className="topbar-user">
                <span className="topbar-user-name">{decoded.name}</span>
                {(decoded.organization_name || decoded.organization_id) && (
                  <span className="topbar-user-org">
                    {decoded.organization_name || decoded.organization_id}
                  </span>
                )}
              </span>
            </Space>
          </Button>
        </Dropdown>
        <span
          className="logout-btn ml-10"
          onClick={() => handleLogout()}
          style={loggingOut ? { cursor: "wait", opacity: 0.7 } : undefined}
          aria-busy={loggingOut}
        >
          Logout
          {loggingOut ? <span className="btn-spinner" /> : <LogoutOutlined />}
        </span>
      </div>
    </div>
  );
};

export default TopBar;
